import { render, staticRenderFns } from "./CompanyAttributeSection.vue?vue&type=template&id=082e6d02&scoped=true"
import script from "./CompanyAttributeSection.vue?vue&type=script&lang=js"
export * from "./CompanyAttributeSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyAttributeSection.vue?vue&type=style&index=0&id=082e6d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e6d02",
  null
  
)

export default component.exports